import { FaCross } from "react-icons/fa";
import { FaCaretDown } from "react-icons/fa6";
import {
  Button,
  Card,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Label,
  UncontrolledDropdown,
} from "reactstrap";
import { RxCross2 } from "react-icons/rx";

const MultiSelectInput = ({ value, setValue, label, options, obj }) => {
  console.log({ value });
  const handleOptionAdd = (title) => {
    setValue([...value, title]);
  };
  const handleObjOptionsAdd = (item) => {
    setValue([item]);
  };
  const handleObjOptionRemove = (item) => {
    setValue([...value]?.filter((i) => i?.name !== item?.name));
  };

  const handleOptionRemove = (title) => {
    setValue([...value]?.filter((i) => i !== title));
  };

  return (
    <div>
      <Label className="figma-input-label">{label}</Label>
      <UncontrolledDropdown>
        <DropdownToggle className="bg-transparent p-0 border-none full-width">
          <div>
            <div className="multi-select-input cursor-pointer">
              <div
                className="d-flex align-items-center bottom-scrollbar gap-2 "
                style={{ overflowX: "scroll" }}
              >
                {value?.map((selected, at) => (
                  <div>
                    <Card
                      key={at}
                      className="selected p-0 d-flex align-items-center flex-row"
                    >
                      <small
                        className="m-0 block f-5"
                        style={{ whiteSpace: "nowrap" }}
                      >
                        {" "}
                        {obj ? selected?.name : selected}
                      </small>
                      <div
                        className="cursor-pointer d-flex align-items-center"
                        onClick={(e) => {
                          e?.stopPropagation();
                          obj
                            ? handleObjOptionRemove(selected)
                            : handleOptionRemove(selected);
                        }}
                      >
                        <RxCross2
                          size={15}
                          strokeWidth={"1px"}
                          color="rgba(222, 34, 40, 1)"
                        />
                      </div>
                    </Card>
                  </div>
                ))}
              </div>
              <div className="color-primary-blue">
                <FaCaretDown size={20} />
              </div>
            </div>
          </div>
        </DropdownToggle>
        <DropdownMenu className=" border-none full-width">
          <div>
            {obj
              ? options?.map((opt, at) => {
                  return (
                    <DropdownItem
                      onClick={() => handleObjOptionsAdd(opt)}
                      style={{
                        animation: `fade-in 0.${at + 1 / 0.5}s linear 1`,
                      }}
                      key={`opt-${at}`}
                    >
                      {opt?.name}
                    </DropdownItem>
                  );
                })
              : options?.map((opt, at) => {
                  return (
                    <DropdownItem
                      onClick={() => handleOptionAdd(opt)}
                      style={{
                        animation: `fade-in 0.${at + 1 / 0.5}s linear 1`,
                      }}
                      key={`opt-${at}`}
                    >
                      {opt}
                    </DropdownItem>
                  );
                })}
          </div>
        </DropdownMenu>
      </UncontrolledDropdown>
    </div>
  );
};

export default MultiSelectInput;
